import React from "react";
import PT from "prop-types";
import Item from "_c/review";
import { Wrap, BgDecor, List } from "./index-styled";
import isempty from "lodash/isEmpty";
import Info from "_c/atoms/Info";
import { Button } from "_c/button";
import { useTheme } from "@/hooks/useTheme";
import SectHeader from "_c/modules/profile/common/SectHeader";

const ns = "saloon_profile:feedback";
const Feedback = ({ t, ...props }) => {
  const theme = useTheme();
  return (
    <Wrap id="profile-feedback-container">
      {theme.__name__ !== "dark" && <BgDecor />}
      <SectHeader>{t(`${ns}.title`)}</SectHeader>
      {isempty(props.reviews) ? (
        <Info style={{ position: "relative", zIndex: 5 }}>
          {props.isOwner ? t(`${ns}.empty_owner`) : t(`${ns}.empty_guest`)}
        </Info>
      ) : (
        <List>
          {props.reviews.map((review) => (
            <Item
              t={t}
              loadComments={props.loadComments}
              isAuthor={props.authUserId === review.client._id}
              key={review._id}
              isFavorite={props.favorites.includes(review._id)}
              authUserId={props.authUserId}
              isAuth={props.isAuth}
              review={review}
              toggleLike={props.toggleLike}
              addComment={props.addComment}
              updateReview={props.updateReview}
              removeComment={props.removeComment}
              openShareModal={props.openShareModal}
            />
          ))}
        </List>
      )}
      {props.isMore && (
        <div style={{ display: "flex" }}>
          <Button
            onClick={() => props.loadMore(props.saloonId, "saloon")}
            disabled={props.loading}
            medium
            centered
          >
            {t("common:load_more")}
          </Button>
        </div>
      )}
    </Wrap>
  );
};
Feedback.propTypes = {
  reviews: PT.array,
  favorites: PT.array,
  isOwner: PT.bool,
  isAuth: PT.bool,
  authUserId: PT.string,
  isMore: PT.bool,
  saloonId: PT.string,

  t: PT.func.isRequired,
  updateReview: PT.func.isRequired,
  addComment: PT.func.isRequired,
  openShareModal: PT.func.isRequired,
  removeComment: PT.func.isRequired,
  toggleLike: PT.func.isRequired,
  updateReview: PT.func.isRequired,
  loadComments: PT.func.isRequired,
  loadMore: PT.func.isRequired,
};
export default Feedback;
